const s = 1e-9, n = (t, r) => {
  const o = 10 ** r;
  return Math.round(t * o) / o;
}, a = (t, r, o = 1e-9) => t - r > o, c = (t, r, o = 1e-9) => Math.abs(t - r) < o;
export {
  s as FLOAT_EPSILON,
  c as isApproxEqual,
  a as isApproxGreater,
  n as roundToDecimals
};
//# sourceMappingURL=round.js.map
